// import {Coords} from "google-map-react";

export default class Location {

    public latitude     : number
    public longitude    : number

    constructor(data: any){
        this.latitude   = _.get(data, "latitude", null)
        this.longitude  = _.get(data, "longitude", null)
    }

    // static initFromGoogleCoords = (location: Coords)=>{
    //     return {
    //         latitude    : location.lat,
    //         longitude   : location.lng,
    //     }
    // }

    toJSON(): JSONObject {
        return {
            latitude   : this.latitude,
            longitude  : this.longitude
        }
    }
}
